export const cart = {
  cartDetails: {
    id: 'Código',
    proceedToCheckout: 'Prosseguir para o pagamento',
    cartName: 'Carrinho #{{code}}',
  },
  cartItems: {
    id: 'Código',
    description: 'Descrição',
    item: 'Item',
    itemPrice: 'Preço do item',
    price: 'Preço',
    offer: 'Oferta',
    newPrice: 'Novo Preço €/TM (Desconto)',
    totalPrice: 'Preço total',
    unit: 'Unidade',
    width: 'Largura',
    quantity: 'QT',
    numberOfSheets: 'Qtd. de pacotes',
    quantityPaquete: 'Chapas / Pacote',
    quantityTubos: 'Tubos por pacote',
    weight: 'Peso por pacote',
    totalWeight: 'Peso total',
    quantityTitle:
      'A quantidade representa o número total deste item no seu carrinho.',
    total: 'Total',
    actions: 'Ações',
    cartTotal: 'Total do carrinho ({{count}} item)',
    cartTotal_other: 'Total do carrinho ({{count}} itens)',
    itemRemoved: 'O item selecionado foi removido. O total do carrinho foi atualizado.',
    caption: 'Conteúdo da cesta de compras.',
    orderExpress: {
      title: 'Compra Expressa',
      important: 'Aproveite as vantagens de um processo de compra mais rápido:',
      topic1: 'Se você tiver mais de um endereço de entrega, vá até A Minha Empresa / Endereços e defina o Endereço Padrão.',
      topic2: 'Se você tiver apenas um endereço, a etapa anterior não é necessária. O método de envio será expresso.',
      topic3: 'Você só precisa inserir o número do pedido abaixo, indicar que deseja esta opção e confirmar os dados do seu pedido no Checkout.',
      agree: 'Validar para Continuar com a Compra Expressa',
      checkout: 'Checkout',
      orderNumber: 'Número do pedido'
    },
    lowNumberOfSheets: 'Não é possível comprar essa quantidade, o peso do balote é inferior ao mínimo permitido de {{weight}} kg',
    packageWeightExceeded: 'Não é possível comprar essa quantidade, o peso do balote é superior ao máximo permitido de {{weight}} kg'
  },
  orderCost: {
    totalWeight: 'Peso total:',
    orderSummary: 'Resumo do pedido',
    subtotal: 'Subtotal após descontos:',
    shipping: 'Envio:',
    estimatedShipping: 'Envio estimado:',
    discount: 'Descontos do pedido:',
    salesTax: 'Imposto sobre vendas:',
    grossTax: 'O total do pedido não inclui os impostos de',
    grossIncludeTax: 'O total do pedido inclui impostos de',
    total: 'Valor Total:',
    value: 'Valor:',
    toBeDetermined: 'A definir',
    taxWarn: 'Impostos não incluidos',
    weight: 'Peso Total:'
  },
  voucher: {
    coupon: 'Você tem um cupom?',
    coupon_other: 'Códigos de cupom',
    couponLabel: 'Insira um código de cupom aqui',
    addCoupon: "Adicionar o coupon",
    apply: 'Aplicar',
    placeholder: 'Código do coupon',
    applyVoucherSuccess: '{{voucherCode}} foi aplicado.',
    removeVoucherSuccess: '{{voucherCode}} foi removido.',
    anchorLabel: 'Insira ou remova seu código de coupon',
    vouchersApplied: 'Cupons aplicados',
    availableCoupons: 'Cupons disponíveis',
    availableCouponsLabel: 'Você pode adicionar esses cupons a este pedido.',
  },
  saveForLaterItems: {
    itemTotal: 'Salvo para mais tarde ({{count}} item)',
    itemTotal_other: 'Salvo para mais tarde ({{count}} itens)',
    cartTitle: 'Carrinho',
    saveForLater: 'Salvar para mais tarde',
    moveToCart: 'Mover para o carrinho',
    stock: 'Stock',
    forceInStock: 'Em stock',
  },
  clearCart: {
    clearCart: 'Limpar carrinho',
    clearingCart: 'Limpando carrinho...',
    cartClearedSuccessfully: 'O carrinho ativo foi limpo com sucesso.',
    areYouSureToClearCart: 'Tem a certeza que quer limpar este carrinho?',
    allItemsWillBeRemoved: 'Todos os itens do seu carrinho ativo serão removidos.',
  },
  validation: {
    cartEntriesChangeDuringCheckout:
      'Durante o processo de pagamento, encontramos problemas com seus itens. Por favor, revise seu carrinho.',
    cartEntryRemoved:
      '{{name}} foi removido do carrinho porque está fora de stock.',
    productOutOfStock:
      '{{name}} foi removido do carrinho porque não há stock suficiente.',
    lowStock: 'A quantidade foi reduzida para {{quantity}} devido à falta de stock.',
    reviewConfiguration:
      'Resolva primeiro os problemas na configuração para o item do carrinho.',
    configurationError:
      'Resolva primeiro os problemas na configuração dos itens do carrinho.',
    pricingError:
      'A configuração de preços não está disponível no momento. Não é possível realizar a compra ou enviar uma cotação. Por favor, tente novamente mais tarde.',
    unresolvableIssues:
      'A configuração do produto exige entradas adicionais no back-end. Como resultado, não é possível continuar. Entre em contato com o suporte.',
    inProgress: 'Em processamento',
  },
};
